<script type="text/javascript">
  export default {
    props: ['type', 'pc', 'website'],
    data() {
      return {
        default_content: {
          type: 'listing-process',
          title: 'Listing process',
          active: 1,
          image: '',
          color: 'white',
          opacity: '',
          pad_t: '5',
          pad_r: '0',
          pad_b: '5',
          pad_l: '0',
          icon: 'ri:home-2-line',
          icon_color: 'revinre',
          h2: 'The listing process',
          h2_color: '',
          h2_desc: `With REVINRE you have the option to sell on your own, sell with help or sell with an agent. Whatever option you choose you can upgrade at any time. If you elect to upgrade your package or go with a “full service” agent, any amount previously spent on packages will be deducted from your total.

If you choose to sell on your own or sell with help, follow the steps below. If you should have any questions, do not hesitate to contact us. We are here to help you every step of the way.`,
          h2_desc_color: '',
          pre_btn: [],
          sec1_image: 'https://s3.revinre.net/perm/revinre/The listing process.png',
          sec1_image_alt: 'The listing process',
          sec1_parts: [
            {
              icon: 'ri:checkbox-line',
              icon_color: 'revinre',
              title: 'Property value',
              title_color: '',
              desc: "Whether you choose to use our Property Valuation service, determine your property value on your own or receive a Comparative Market Analysis from one of our agents, we are here to help you get the right price for your property.",
              desc_color: '',
            },
            {
              icon: 'ri:checkbox-line',
              icon_color: 'revinre',
              title: 'Pick your package',
              title_color: '',
              desc: "Here's where REVINRE really distinguishes itself from all competitors: you can either use our free Basic package, or select and pay for only those services you feel you need and want.",
              desc_color: '',
            },
            {
              icon: 'ri:checkbox-line',
              icon_color: 'revinre',
              title: 'Property details',
              title_color: '',
              desc: "Tell us about your property so that we can properly display the information in the MLS and leading websites. We will call you upon your submission to fill in all the blanks and review everything you have submitted to make sure we portray your property accurately and in its best light.",
              desc_color: '',
            },
          ],
          sec2_image: 'https://s3.revinre.net/perm/revinre/Professional Photography.png',
          sec2_image_alt: 'Professional Photography',
          sec2_parts: [
            {
              icon: 'ri:checkbox-line',
              icon_color: 'revinre',
              title: 'Upload photos',
              title_color: '',
              desc: "Having good photos of your property is one of the most important parts of the selling process. We make it easy to upload your existing property photos or if you choose to use any of our upgraded packages we take care of this part for you with our professional photography service.",
              desc_color: '',
            },
            {
              icon: 'ri:checkbox-line',
              icon_color: 'revinre',
              title: 'Sign documents',
              title_color: '',
              desc: "After we make sure all of your property details are as accurate as possible we will send all of the nessesary paperwork needed to get you listed on the MLS through DocuSign for signatures.",
              desc_color: '',
            },
            {
              icon: 'ri:checkbox-line',
              icon_color: 'revinre',
              title: 'Get listed',
              title_color: '',
              desc: "Once the listing paperwork is signed and we have received all of the photos for your property we will work on getting you entered into the MLS and leading websites.",
              desc_color: '',
            },
          ],
          post_btn: [],
        },
      }
    },
    created() {
      if(this.pc && this.pc.init == 'Yes') { for(var i in this.default_content) { this.pc[i] = this.default_content[i]; } this.pc.init = ''; }
      if(!this.pc.pre_btn) { this.pc.pre_btn = []; this.$forceUpdate(); }
      if(!this.pc.post_btn) { this.pc.post_btn = []; this.$forceUpdate(); }
      if(!this.pc.sec1_parts) { this.pc.sec1_parts = []; this.$forceUpdate(); }
      if(!this.pc.sec2_parts) { this.pc.sec2_parts = []; this.$forceUpdate(); }
    },
    methods: {

    }
  }
</script>

<template>
  <section>

    <div v-if="type == 'editor'">
      <div class="p-3">
        <div class="row">
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" v-model="pc.active" Title="Active :" :Options="[{name:'Yes',value:1},{name:'No',value:0}]" v-tippy content="Display this section on the live website?"></w-field>
          </div>
        </div>
        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Section background and padding :</h6>
        <div class="row">
          <div class="col-sm-4">
            <w-field SimpleDataType="String" v-model="pc.image" Title="Background image URL :"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" Title="Background color :" :Options="theme_colors" v-model="pc.color"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="Number" v-model="pc.opacity" Min="0" Max="10" Title="Background color opacity :" v-tippy content="Background color transparency (0 through 10)"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="Number" v-model="pc.pad_t" Min="0" Max="20" Title="Top padding :" v-tippy content="Padding for the top of the section (0 through 20)"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="Number" v-model="pc.pad_r" Min="0" Max="20" Title="Right padding :" v-tippy content="Padding for the right of the section (0 through 20)"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="Number" v-model="pc.pad_b" Min="0" Max="20" Title="Bottom padding :" v-tippy content="Padding for the bottom of the section (0 through 20)"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="Number" v-model="pc.pad_l" Min="0" Max="20" Title="Left padding :" v-tippy content="Padding for the left of the section (0 through 20)"></w-field>
          </div>
        </div>
        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Section H2 title :</h6>
        <div class="row">
          <div class="col-sm-6">
            <w-field SimpleDataType="String" v-model="pc.icon" Title="Section icon :" v-tippy content="Section icon"></w-field>
          </div>
          <div class="col-sm-6">
            <w-field SimpleDataType="String List, Single" v-model="pc.icon_color" Title="Section icon color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-6">
            <w-field SimpleDataType="String" v-model="pc.h2" Title="H2 title :" v-tippy content="Section title"></w-field>
          </div>
          <div class="col-sm-6">
            <w-field SimpleDataType="String List, Single" v-model="pc.h2_color" Title="H2 title color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-6">
            <w-field SimpleDataType="Textarea" v-model="pc.h2_desc" Title="H2 description :" v-tippy content="Section description appearing below the section title"></w-field>
          </div>
          <div class="col-sm-6">
            <w-field SimpleDataType="String List, Single" v-model="pc.h2_desc_color" Title="H2 description color : " :Options="theme_colors"></w-field>
          </div>
        </div>

        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Top buttons :</h6>
        <div class="form-group">
          <draggable handle=".handle" v-bind="{animation: 200}" v-model="pc.pre_btn">
            <transition-group tag="div">
              <div v-for="(btn, btn_i) in pc.pre_btn" :key="'f1'+btn_i">
                <div class="row m-0 align-items-end">
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String" v-model="btn.pre_icon" Title="Pre icon :"></w-field>
                  </div>
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String" v-model="btn.text" Title="Text :"></w-field>
                  </div>
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String" v-model="btn.post_icon" Title="Post icon :"></w-field>
                  </div>
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String List, Single" v-model="btn.color" Title="Color : " :Options="theme_colors"></w-field>
                  </div>
                  <div class="col p-0">
                    <w-field SimpleDataType="String" v-model="btn.url" Title="URL :"></w-field>
                  </div>
                  <div class="_w-40 pb-2">
                    <button class="btn btn-white" type="button" v-tippy content="Delete" @click="pc.pre_btn.splice(btn_i, 1); $forceUpdate()"><Icon icon="ri:delete-bin-line"></Icon></button>
                  </div>
                  <div class="_w-40 pb-2">
                    <button class="btn btn-white handle" type="button" v-tippy content="Drag to arrange"><Icon icon="ri:drag-move-2-fill"></Icon></button>
                  </div>
                </div>
              </div>
            </transition-group>
          </draggable>
          <button class="btn btn-sm btn-primary" type="button" @click="pc.pre_btn.push({color: '', pre_icon: '', text: '', post_icon: '', url: ''}); $forceUpdate()"><Icon icon="ri:add-line" height="18"></Icon> Add button</button>
        </div>
        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Listing process: first section :</h6>
        <div class="row">
          <div class="col-sm-6">
            <w-field SimpleDataType="String" v-model="pc.sec1_image" Title="Section 1 image URL :"></w-field>
          </div>
          <div class="col-sm-6">
            <w-field SimpleDataType="String" v-model="pc.sec1_image_alt" Title="Section 1 image ALT text :"></w-field>
          </div>
        </div>
        <div class="form-group">
          <draggable handle=".handle" v-bind="{animation: 200}" v-model="pc.sec1_parts">
            <transition-group tag="div">
              <div v-for="(sec, sec_i) in pc.sec1_parts" :key="'f3'+sec_i" class="">
                <div class="row ">
                  <div class="col-3">
                    <w-field SimpleDataType="String" v-model="sec.icon" Title="Icon :"></w-field>
                  </div>
                  <div class="col-3">
                    <w-field SimpleDataType="String List, Single" v-model="sec.icon_color" Title="Icon color : " :Options="theme_colors"></w-field>
                  </div>
                  <div class="col-3">
                    <w-field SimpleDataType="String" v-model="sec.title" Title="Title :"></w-field>
                  </div>
                  <div class="col">
                    <w-field SimpleDataType="String List, Single" v-model="sec.title_color" Title="Title color : " :Options="theme_colors"></w-field>
                  </div>
                  <div class="_w-40 pb-2">
                    <label>.</label>
                    <button class="btn btn-white" type="button" v-tippy content="Delete" @click="pc.sec1_parts.splice(sec_i, 1); $forceUpdate()"><Icon icon="ri:delete-bin-line"></Icon></button>
                  </div>
                  <div class="_w-40 pb-2">
                    <label>.</label>
                    <button class="btn btn-white handle" type="button" v-tippy content="Drag to arrange"><Icon icon="ri:drag-move-2-fill"></Icon></button>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-9 ">
                    <w-field SimpleDataType="Textarea" v-model="sec.desc" Title="Description :"></w-field>
                  </div>
                  <div class="col-3">
                    <w-field SimpleDataType="String List, Single" v-model="sec.desc_color" Title="Description color : " :Options="theme_colors"></w-field>
                  </div>
                </div>
              </div>
            </transition-group>
          </draggable>
          <button class="btn btn-sm btn-primary" type="button" @click="pc.sec1_parts.push({icon: '', icon_color: '', title: '', title_color: '', desc: '', desc_color: ''}); $forceUpdate()"><Icon icon="ri:add-line" height="18"></Icon> Add step</button>
        </div>

        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Listing process: second section :</h6>
        <div class="row">
          <div class="col-sm-6">
            <w-field SimpleDataType="String" v-model="pc.sec2_image" Title="Section 2 image URL :"></w-field>
          </div>
          <div class="col-sm-6">
            <w-field SimpleDataType="String" v-model="pc.sec2_image_alt" Title="Section 2 image ALT text :"></w-field>
          </div>
        </div>
        <div class="form-group">
          <draggable handle=".handle" v-bind="{animation: 200}" v-model="pc.sec2_parts">
            <transition-group tag="div">
              <div v-for="(sec, sec_i) in pc.sec2_parts" :key="'f3'+sec_i">
                <div class="row ">
                  <div class="col-3">
                    <w-field SimpleDataType="String" v-model="sec.icon" Title="Icon :"></w-field>
                  </div>
                  <div class="col-3">
                    <w-field SimpleDataType="String List, Single" v-model="sec.icon_color" Title="Icon color : " :Options="theme_colors"></w-field>
                  </div>
                  <div class="col-3">
                    <w-field SimpleDataType="String" v-model="sec.title" Title="Title :"></w-field>
                  </div>
                  <div class="col">
                    <w-field SimpleDataType="String List, Single" v-model="sec.title_color" Title="Title color : " :Options="theme_colors"></w-field>
                  </div>
                  <div class="_w-40 pb-2">
                    <label>.</label>
                    <button class="btn btn-white" type="button" v-tippy content="Delete" @click="pc.sec2_parts.splice(sec_i, 1); $forceUpdate()"><Icon icon="ri:delete-bin-line"></Icon></button>
                  </div>
                  <div class="_w-40 pb-2">
                    <label>.</label>
                    <button class="btn btn-white handle" type="button" v-tippy content="Drag to arrange"><Icon icon="ri:drag-move-2-fill"></Icon></button>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-9 ">
                    <w-field SimpleDataType="Textarea" v-model="sec.desc" Title="Description :"></w-field>
                  </div>
                  <div class="col-3">
                    <w-field SimpleDataType="String List, Single" v-model="sec.desc_color" Title="Description color : " :Options="theme_colors"></w-field>
                  </div>
                </div>
              </div>
            </transition-group>
          </draggable>
          <button class="btn btn-sm btn-primary" type="button" @click="pc.sec2_parts.push({title: '', desc: ''}); $forceUpdate()"><Icon icon="ri:add-line" height="18"></Icon> Add step</button>
        </div>

        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Bottom buttons :</h6>
        <div class="form-group">
          <draggable handle=".handle" v-bind="{animation: 200}" v-model="pc.post_btn">
            <transition-group tag="div">
              <div v-for="(btn, btn_i) in pc.post_btn" :key="'f2'+btn_i">
                <div class="row m-0 align-items-end">
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String" v-model="btn.pre_icon" Title="Pre icon :"></w-field>
                  </div>
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String" v-model="btn.text" Title="Text :"></w-field>
                  </div>
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String" v-model="btn.post_icon" Title="Post icon :"></w-field>
                  </div>
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String List, Single" v-model="btn.color" Title="Color : " :Options="theme_colors"></w-field>
                  </div>
                  <div class="col p-0">
                    <w-field SimpleDataType="String" v-model="btn.url" Title="URL :"></w-field>
                  </div>
                  <div class="_w-40 pb-2">
                    <button class="btn btn-white" type="button" v-tippy content="Delete" @click="pc.post_btn.splice(btn_i, 1); $forceUpdate()"><Icon icon="ri:delete-bin-line"></Icon></button>
                  </div>
                  <div class="_w-40 pb-2">
                    <button class="btn btn-white handle" type="button" v-tippy content="Drag to arrange"><Icon icon="ri:drag-move-2-fill"></Icon></button>
                  </div>
                </div>
              </div>
            </transition-group>
          </draggable>
          <button class="btn btn-sm btn-primary" type="button" @click="pc.post_btn.push({color: '', pre_icon: '', text: '', post_icon: '', url: ''}); $forceUpdate()"><Icon icon="ri:add-line" height="18"></Icon> Add button</button>
        </div>

      </div>
    </div>

    <div v-else class="container-fluid">
      <div class="position-absolute _pos-l-0 _pos-t-0 _pos-r-0 _pos-b-0 _z-n1 _bg-repeat-none _bg-size-cover _bg-position-center" :style="'background-image: url('+(pc['image'] ? fullurlencode(pc['image']) : '')+')'"></div>
      <div class="position-absolute _pos-l-0 _pos-t-0 _pos-r-0 _pos-b-0 _z-n1" :class="'bg-'+pc['color']+' _o-'+pc['opacity']"></div>
      <div class="container-fluid m_py-35" :class="'pt-'+pc['pad_t']+' pr-'+pc['pad_r']+' pb-'+pc['pad_b']+' pl-'+pc['pad_l']">

        <div class="text-center _w-m-900 mx-auto mb-5">
          <Icon v-if="pc['icon']" :icon="pc['icon']" height="45" class="mb-2" :class="'text-'+pc['icon_color']"></Icon>
          <h2 v-if="pc['h2']" class="mb-3" :class="'text-'+pc['h2_color']" data-aos="fade-zoom-in">{{pc['h2']}}</h2>
          <p v-if="pc['h2_desc']" class="text-pre-wrap" :class="'text-'+pc['h2_desc_color']" data-aos="fade-zoom-in">{{pc['h2_desc']}}</p>
        </div>

        <div v-if="pc['pre_btn'] && pc['pre_btn'].length" class="text-center mb-5">
          <a v-for="(btn, btn_i) in pc['pre_btn']" :key="btn_i" v-if="btn['text'] || btn['pre_icon'] || btn['post_icon']" class="btn btn-lg mb-3 mx-3" :class="'btn-'+btn['color']" :href="btn['url']" target="_blank">
            <Icon v-if="btn['pre_icon']" :icon="btn['pre_icon']" height="20"></Icon>
            <span v-if="btn['pre_icon'] && btn['text']" class="border-left mx-3"></span>
            {{ btn['text'] }}
            <span v-if="btn['post_icon'] && btn['text']" class="border-left mx-3"></span>
            <Icon v-if="btn['post_icon']" :icon="btn['post_icon']" height="20"></Icon>
          </a>
        </div>


        <div class="row align-items-center justify-content-center">
          <div class="col-lg-5 col-sm-6">
            <div data-aos="fade-zoom-in"><img v-if="pc['sec1_image']" :src="formatImage(pc['sec1_image']) " :alt="pc['sec1_image_alt']" class="img-fluid mx-auto d-block"></div>
          </div>
          <div class="col-lg-5 offset-lg-1">
            <div v-for="(sec, sec_i) in pc.sec1_parts" :key="sec_i" class="mb-4">
              <div v-if="sec['icon']" class="float-left" data-aos="fade-zoom-in"><Icon :icon="sec['icon']" height="30" class="mr-3" :class="'text-'+sec['icon_color']"></Icon></div>
              <h3 v-if="sec['title']" class="mb-3" :class="'text-'+sec['title_color']" data-aos="fade-zoom-in">{{sec['title']}}</h3>
              <p v-if="sec['title']" :class="'text-'+sec['desc_color']" data-aos="fade-zoom-in">{{sec['desc']}}</p>
            </div>
          </div>
        </div>
        <div class="row align-items-center justify-content-center mt-5 pt-4">
          <div class="col-lg-5 ">
            <div v-for="(sec, sec_i) in pc.sec2_parts" :key="sec_i" class="mb-4">
              <div v-if="sec['icon']" class="float-left" data-aos="fade-zoom-in"><Icon :icon="sec['icon']" height="30" class="mr-3" :class="'text-'+sec['icon_color']"></Icon></div>
              <h3 v-if="sec['title']" class="mb-3" :class="'text-'+sec['title_color']" data-aos="fade-zoom-in">{{sec['title']}}</h3>
              <p v-if="sec['title']" :class="'text-'+sec['desc_color']" data-aos="fade-zoom-in">{{sec['desc']}}</p>
            </div>
          </div>
          <div class="col-lg-5 col-sm-6 offset-lg-1">
            <div data-aos="fade-zoom-in"><img v-if="pc['sec2_image']" :src="formatImage(pc['sec2_image']) " :alt="pc['sec2_image_alt']" class="img-fluid mx-auto d-block"></div>
          </div>
        </div>

        <div v-if="pc['post_btn'] && pc['post_btn'].length" class="text-center mt-5">
          <a v-for="(btn, btn_i) in pc['post_btn']" :key="btn_i" v-if="btn['text'] || btn['pre_icon'] || btn['post_icon']" class="btn btn-lg mb-3 mx-3" :class="'btn-'+btn['color']" :href="btn['url']" target="_blank">
            <Icon v-if="btn['pre_icon']" :icon="btn['pre_icon']" height="20"></Icon>
            <span v-if="btn['pre_icon'] && btn['text']" class="border-left mx-3"></span>
            {{ btn['text'] }}
            <span v-if="btn['post_icon'] && btn['text']" class="border-left mx-3"></span>
            <Icon v-if="btn['post_icon']" :icon="btn['post_icon']" height="20"></Icon>
          </a>
        </div>

      </div>
    </div>
  </section>

</template>
